import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, CircularProgress, Box, Button, Stack, FormControl, MenuItem, InputLabel, Select, TextField, Alert } from '@mui/material';
import ticketApi from '../../api/ticketApi';
import { AuthContext } from '../../auth/AuthContext';
import BackButtonDesktop from '../../components/BackButtonDesktop';
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};
export default function TicketDetailPageMobile() {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('');
  const [level, setLevel] = useState('');
  const STATI = ['APERTO','IN_LAVORAZIONE','CHIUSO'];
  const LIVELLI = ['PRIMO_LIVELLO','SECONDO_LIVELLO'];

  useEffect(() => {
    fetchTicket();
  }, []);

  const fetchTicket = async () => {
    try {
      const res = await ticketApi.get(id);
      setTicket(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

  const handleAddMessage = async () => {
    try {
      console.log("id",id);
      console.log("message",message);
      await ticketApi.addMessage(id, message);
      setMessage('');
      fetchTicket();
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

  const handleChangeStatus = async () => {
    try {
      await ticketApi.changeStatus(id, status);
      fetchTicket();
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

  const handleChangeLevel = async () => {
    try {
      await ticketApi.changeLevel(id, level);
      fetchTicket();
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

  if (!ticket) return <Container>Caricamento...</Container>;

  return (
    <Container>
      {error && <Alert severity="error">{error}</Alert>}
      <Typography variant="h4">Ticket #{ticket.id}</Typography>
      <Typography>Oggetto: {ticket.oggetto}</Typography>
      <Typography>Stato: {ticket.stato}</Typography>
      <Typography>Livello: {ticket.livello}</Typography>

      <Stack spacing={2} sx={{ mt: 2 }}>
        <Typography variant="h6">Messaggi</Typography>
        {ticket.messages?.map((m) => (
          <Typography key={m.id}>
            [{m.authorType}] {m.message}
          </Typography>
        ))}

        <TextField
          label="Nuovo messaggio"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          multiline
        />
        <Button variant="contained" onClick={handleAddMessage}>
          Aggiungi messaggio
        </Button>

        {user.role === 'ADMIN' && (
          <>
            <TextField
              label="Cambia stato"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            />
            <Button variant="outlined" onClick={handleChangeStatus}>
              Aggiorna stato
            </Button>

            <TextField
              label="Cambia livello"
              value={level}
              onChange={(e) => setLevel(e.target.value)}
            />
            <Button variant="outlined" onClick={handleChangeLevel}>
              Aggiorna livello
            </Button>
          </>
        )}
      </Stack>
    </Container>
  );
}